import { connect } from 'react-redux';
import { compose } from 'redux';

import withSessionRequired from 'hocs/withSessionRequired';

import VerificationSent from 'components/verification/VerificationSent';

function mapStateToProps({user}) {
  return {
    email: user.email
  };
}

export default compose(
  withSessionRequired,
  connect(mapStateToProps)
)(VerificationSent);
